import { PKG } from '../analytics/analyticsConsts';
import { ANALYTICS } from '../firebase/firebase';
import { METHOD, Request } from '../utils/http';
import { Application, Decision } from './api';
import { URL } from './apiConstants';

export interface GetApplicationRequest {
  token: string;
  applicationUUID?: string;
  deviceID?: string;
}

export interface GetApplicationEvaluationResponse {
  headers?: {
    'x-imprint-delay-in-ms'?: string;
  };
  body?: {
    application?: Application;
    decision?: Decision;
    displayState?: string;
    signUpStatus?: string;
    code?: string;
    message?: string;
    showCounterOffer?: boolean;
  };
  code?: number;
  message?: string;
}

export const GetApplicationEvaluation = async (
  requestParams: GetApplicationRequest
): Promise<
  [
    GetApplicationEvaluationResponse | null,
    GetApplicationEvaluationResponse | null,
  ]
> => {
  try {
    if (!requestParams.applicationUUID) {
      throw Error();
    }

    const data = await Request({
      url: requestParams.applicationUUID
        ? `${URL.APPLICATION_EVALUATION}/${requestParams.applicationUUID}/evaluation`
        : URL.APPLICATION_EVALUATION,
      method: METHOD.GET,
      token: requestParams.token,
      deviceID: requestParams.deviceID,
      headers: true,
    });

    return [data as GetApplicationEvaluationResponse, null];
  } catch (error: any) {
    ANALYTICS.funcError(PKG, 'GetApplicationEvaluation', JSON.stringify(error));
    // override the string error code with http error code
    return [
      null,
      {
        code: error?.__httpStatus ?? 500,
        message: error?.message ?? 'Unknown error',
      } as GetApplicationEvaluationResponse,
    ];
  }
};
